(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TIMEOUT_MS = 2500;
  var DEBUG = typeof location !== 'undefined' && /[?&]debug-hero(=|&|$)/.test(location.search);

  function debug(reason, extra) {
    if (!DEBUG) return;
    if (extra !== undefined) console.debug('[hero-slider]', reason, extra);
    else console.debug('[hero-slider]', reason);
  }

  function shouldEnableHeroVideo() {
    if (reducedMotion.matches) return { enabled: false, reason: 'reduced-motion' };
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData === true) return { enabled: false, reason: 'save-data' };
      if (conn.effectiveType === '2g' || conn.effectiveType === 'slow-2g') {
        return { enabled: false, reason: 'effective-type:' + conn.effectiveType };
      }
    }
    return { enabled: true, reason: 'ok' };
  }

  function pickVideoUrl(videoEl) {
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    var desktop = videoEl.dataset.heroVideoDesktop || '';
    var mobile = videoEl.dataset.heroVideoMobile || '';
    if (isDesktop) return desktop || mobile || null;
    return mobile || desktop || null;
  }

  function attachSource(state) {
    if (!state.el || state.sourced) return;
    var url = pickVideoUrl(state.el);
    if (!url) { debug('no-source', state.index); return; }
    var source = document.createElement('source');
    source.src = url;
    source.type = 'video/mp4';
    state.el.appendChild(source);
    try { state.el.load(); } catch (e) {}
    state.sourced = true;
  }

  function detachSource(state) {
    if (!state.el) return;
    while (state.el.firstChild) state.el.removeChild(state.el.firstChild);
    state.el.removeAttribute('src');
    try { state.el.load(); } catch (e) {}
    state.sourced = false;
    state.ready = false;
    state.el.classList.remove('is-playing');
  }

  function tryPlay(state) {
    if (!state.el) return;
    var p;
    try { p = state.el.play(); } catch (e) { debug('play-threw', e && e.name); return; }
    if (p && typeof p.catch === 'function') {
      p.catch(function (err) {
        var name = err && err.name;
        if (name === 'AbortError') { debug('aborted', state.index); return; }
        debug('autoplay-rejected', name || 'unknown');
        state.el.classList.remove('is-playing');
      });
    }
  }

  function activateVideo(state) {
    if (!state.el || !state.gateOk) return;

    if (state.ready) {
      tryPlay(state);
      return;
    }

    attachSource(state);
    if (!state.sourced) return;

    if (state.activationTimeout) clearTimeout(state.activationTimeout);
    state.activationTimeout = setTimeout(function () {
      if (!state.ready) {
        debug('timeout', state.index);
        detachSource(state);
      }
    }, TIMEOUT_MS);
  }

  function deactivateVideo(state) {
    if (!state.el) return;
    if (state.activationTimeout) {
      clearTimeout(state.activationTimeout);
      state.activationTimeout = null;
    }
    try { state.el.pause(); } catch (e) {}
    state.el.classList.remove('is-playing');
  }

  function bindVideoEvents(state, isActive) {
    if (!state.el) return;
    state.el.addEventListener('canplay', function () {
      if (state.ready) return;
      state.ready = true;
      if (state.activationTimeout) {
        clearTimeout(state.activationTimeout);
        state.activationTimeout = null;
      }
      if (isActive()) tryPlay(state);
    });
    state.el.addEventListener('playing', function () {
      state.el.classList.add('is-playing');
      debug('playing', state.index);
    });
    state.el.addEventListener('pause', function () {
      state.el.classList.remove('is-playing');
    });
  }

  function initSlider(root) {
    if (root.dataset.heroSliderBound === 'true') return;
    root.dataset.heroSliderBound = 'true';

    var slides = root.querySelectorAll('[data-hero-slider-slide]');
    var dots = root.querySelectorAll('[data-hero-slider-dot]');
    var prevBtn = root.querySelector('[data-hero-slider-prev]');
    var nextBtn = root.querySelector('[data-hero-slider-next]');
    if (slides.length === 0) return;

    var current = 0;
    var autoplayEnabled = root.dataset.heroSliderAutoplay === 'true' && !reducedMotion.matches;
    var autoplayDelay = parseInt(root.dataset.heroSliderSpeed, 10) || 5000;
    var timer = null;
    var transitioning = false;

    var gate = shouldEnableHeroVideo();
    debug('gate', gate.reason);

    var videoStates = [];
    slides.forEach(function (slide, i) {
      var v = slide.querySelector('[data-hero-video]');
      var state = {
        index: i,
        el: v,
        sourced: false,
        ready: false,
        gateOk: gate.enabled && !!v,
        activationTimeout: null
      };
      videoStates.push(state);
      if (v) bindVideoEvents(state, function () { return current === state.index; });
    });

    function show(index) {
      var target = (index + slides.length) % slides.length;
      if (target === current || transitioning) return;
      transitioning = true;

      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      deactivateVideo(videoStates[current]);

      slides[target].classList.add('is-active');
      slides[target].removeAttribute('aria-hidden');
      activateVideo(videoStates[target]);

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === target);
      });

      current = target;

      // Allow next transition after the CSS transition completes
      setTimeout(function () { transitioning = false; }, 850);
    }

    // --- Dot navigation ---
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.heroSliderDot, 10));
        restartAutoplay();
      });
    });

    // --- Arrow navigation ---
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); restartAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); restartAutoplay(); });

    // --- Keyboard ---
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); restartAutoplay(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); restartAutoplay(); }
    });

    // --- Touch swipe ---
    var touchStartX = 0;
    var touchStartY = 0;
    var SWIPE_THRESHOLD = 50;

    root.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        show(dx < 0 ? current + 1 : current - 1);
        restartAutoplay();
      }
    }, { passive: true });

    // --- Autoplay ---
    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= 1) return;
      stopAutoplay();
      timer = setInterval(function () {
        if (!document.body.contains(root)) { stopAutoplay(); return; }
        if (document.hidden) return;
        show(current + 1);
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    // Fade in the slider once the first slide image has loaded
    var firstImg = slides[0] && slides[0].querySelector('img');
    if (firstImg) {
      if (firstImg.complete) {
        root.classList.add('is-ready');
      } else {
        firstImg.addEventListener('load', function () { root.classList.add('is-ready'); }, { once: true });
        setTimeout(function () { root.classList.add('is-ready'); }, 3000);
      }
    } else {
      root.classList.add('is-ready');
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // Kick the first slide's video.
    if (videoStates[0]) activateVideo(videoStates[0]);

    // Pause active video when tab is hidden; resume when visible.
    document.addEventListener('visibilitychange', function () {
      if (!document.body.contains(root)) return;
      var active = videoStates[current];
      if (!active) return;
      if (document.hidden) {
        deactivateVideo(active);
      } else if (active.gateOk) {
        activateVideo(active);
      }
    });

    startAutoplay();

    // --- Shopify editor integration ---
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var index = parseInt(e.target.dataset.heroSliderSlide, 10);
      if (!isNaN(index)) {
        stopAutoplay();
        show(index);
      }
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (!root.contains(e.target)) return;
      startAutoplay();
    });
  }

  function init() {
    document.querySelectorAll('[data-hero-slider]').forEach(initSlider);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
